import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-594a4de4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "no-data-box" };
const _hoisted_2 = { class: "text" };
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        icon: { default: "" },
        text: { default: "暂无数据" }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.icon !== '')
                    ? (_openBlock(), _createBlock(_component_svg_icon, {
                        key: 0,
                        class: "no-data",
                        "icon-class": __props.icon
                    }, null, 8, ["icon-class"]))
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default", {}, () => [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.text), 1)
                ]),
                _renderSlot(_ctx.$slots, "info")
            ]));
        };
    }
});
